<template>
  <v-autocomplete
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    label="Mitarbeiter/Employee"
    :items="users"
    item-title="title"
    item-value="id"
    density="compact"
    class="dropDownMenu"
    variant="solo"
    hide-details
  />
</template>

<script>
export default {
  props: {
    dropDownEmpUsers: {type: Object,required: true, },
    modelValue: {type: [String, Number, null],default: null,},
  },

  emits: ['update:modelValue'],

  computed: {
    users() {
      return this.dropDownEmpUsers.users.map(user => ({
        title: `${user.first_name} ${user.last_name}`,
        id: user.id,
      }))
    },
  },

  mounted() {
    // wenn parent keinen Wert gesetzt hat → default auf current_user_id
    if (this.modelValue === null && this.dropDownEmpUsers.current_user_id) {
      this.$emit('update:modelValue', this.dropDownEmpUsers.current_user_id)
    }
  },
}
</script>

<style scoped>
.v-autocomplete {
  color: black;
  background-color: white;
  border-radius: 8px;
  font-size: xx-small;
  min-width: 20.25rem;
  box-shadow: 0px 6px 15px hsla(0, 0%, 0%, 0.5);
}
</style>
